var map = {
	"./address_image.svg": 89,
	"./animated_logo.svg": 90,
	"./animated_profile.png": 91,
	"./at_logo.jpg": 92,
	"./blogs_image.svg": 93,
	"./cloud_infrastructure.svg": 94,
	"./codeInLogo.png": 95,
	"./contactMail.png": 96,
	"./coursera_logo.png": 97,
	"./data_science.svg": 98,
	"./deeplearning_ai_logo.png": 99,
	"./delhivery_logo.png": 100,
	"./developerActivity.svg": 101,
	"./dsc_logo.png": 102,
	"./education.svg": 103,
	"./experience.svg": 104,
	"./feelingProud.svg": 105,
	"./freecopy_logo.png": 106,
	"./fullstack.svg": 107,
	"./gcp_logo.png": 108,
	"./github_logo.png": 109,
	"./googleAssistant.jpg": 110,
	"./googleAssistant.svg": 111,
	"./google_logo.png": 112,
	"./iapp.jpeg": 113,
	"./ibm_logo.png": 114,
	"./intel_logo.jpg": 115,
	"./iu_logo.png": 116,
	"./jsFramework.svg": 117,
	"./lakhdeepDP.jpg": 118,
	"./legato_logo.png": 119,
	"./manOnTable.svg": 120,
	"./microsoft_logo.png": 121,
	"./mozilla_logo.png": 122,
	"./muffito_logo.png": 123,
	"./nextuLogo.jpg": 124,
	"./nptel_logo.png": 125,
	"./portfolio.gif": 126,
	"./programmer.svg": 127,
	"./projects_image.svg": 128,
	"./psbte_logo.png": 129,
	"./ptu_logo.png": 130,
	"./pup_Logo.png": 131,
	"./pwa.png": 132,
	"./saayaHealthLogo.png": 133,
	"./sharechat.webp": 134,
	"./sparkview.png": 135,
	"./stack-overflow_logo.png": 136,
	"./stanford_logo.png": 137,
	"./talksCardBack.svg": 138,
	"./talksCardBackAlt.svg": 139,
	"./tiktok_logo.png": 140,
	"./ui_ux_design.svg": 141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;